module.exports = __webpack_public_path__ + "static/RealtyIcon-82cc914d71d4ebcd9c5ea06fa47a9b5c.png";